module.exports = __webpack_public_path__ + "img/hof_yes.c0241f60.png";